import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import moment from 'moment';
import PageTracker from '../../../common/PageTrackerHelper';
import tableTemplate from '../common/table-template'

export default {
  name: 'ShipmentSummary',
  components: {
    VueElementLoading,
    Paginate,
    'load-table-template' : tableTemplate,
  },
  mixins:[PageTracker],
  data: function() {
    return {
      RouteID: '',
      isLoading: false,
      showTables: false,
      RouteMasterData:[],
      RouteMasterlogData:[],
      RouteMasterModel: false,
      RouteMasterlogModel: false,
      Routeloader: false,
      showShipmentsList: [],
      RouteMasterColumns:[
        {
          "label": 'RouteId',
          "key": "routesmasterid"
        },
        {
          "label": 'Route Name',
          "key": "routename"
        },
        // {
        //   "label": 'Delivery Type',
        //   "key": "deliverytype"
        // },
        // {
        //   "label": 'Hub Name',
        //   "key": "hubname"
        // },
        {
          "label": 'Delivery User',
          "key": "deliveryusername"
        },
        {
          "label": 'Status',
          "key": "rstatus"
        },
        {
          "label": 'Initial ShipmentCount',
          "key": "initialshipmentcount"
        },
        {
          "label": 'Shipment Count',
          "key": "shipmentcount"
        },
        {
          "label": 'Created By',
          "key": "createdby"
        },
        {
          "label": 'Created Date',
          "key": "createddate"
        },
        {
          "label": 'LastModified By',
          "key": "lastmodifiedby"
        },
        {
          "label": 'LastModified Date',
          "key": "lastmodifieddate"
        },
      ],
      RouteMasterlogColumns:[
        {
          "label": 'RouteId',
          "key": "routeid"
        },
        {
          "label": 'Action Type',
          "key": "actiontype"
        },
        {
          "label": 'ShippingIds',
          "key": "shippingids"
        },
        {
          "label": 'Created By',
          "key": "createdby"
        },
        {
          "label": 'Created Date',
          "key": "CreatedDate"
        },
        {
          "label": 'Comments',
          "key": "comments"
        },
      ]
    }
  },
  created: function() {
  },
  async mounted() {
    let validateUser = await this.validateJwtToken();
    let setLocusFlag = await this.checkIsLocusEnableforhub()
    if(!setLocusFlag) {
      this.$alertify.error('Your are not authorized user/hub for locus module.!')
      this.$router.push('/dashboard')
      return false;
    }
    console.log('setLocusFlag RouteSummary----->>', setLocusFlag);
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubname = this.localhubdetails;
    this.userRoles = userdetail.userrole[0];

    let TrackerInfo = {
        projectname:"Last Mile",
        type:"Web",
        userid:this.localuserid,
        username:this.localusermailid,
        meta: {
            "event":""
        }
    }
    let result  = this.PageTracker(TrackerInfo);
  },
  filters: {
    changeDateFormat: function(date) {
      if (date != null || date != '') {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
    }
  },
  methods: {
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.isLoading = true;
          this.showTables = false;

          let Payload = {
            RouteId: this.RouteID.trim()
          }

          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'locus/get/route/summary',
            'data': Payload
          })
          .then(result => {
            // console.log("result",result);
            if( result.data.code === 200 ) {
              this.RouteMasterData = [result.data.RoutemasterData];
              this.RouteMasterlogData = result.data.RoutemasterlogData;
              //this.$alertify.success('Record found.!');
            } else {
              this.$alertify.error(result.data.message);
              this.RouteMasterData = [];
              this.RouteMasterlogData = [];
            }
            this.isLoading = false;
            this.Routeloader =false
            this.showTables = true;
          }, error => {
            this.isLoading = false;
            this.Routeloader =false
          })
        }
      }).catch(() => {
        this.isLoading = false;
        this.Routeloader =false
      });
      this.isLoading = false;
      this.Routeloader =false
    },

    clear() {
      this.isLoading = false;
      this.showTables = false;
      this.Routeloader =false
      this.RouteID = '';
      this.RouteMasterData = '';
      this.RouteMasterlogData = '';
      this.errors.clear();
      this.$validator.reset();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/RouteSummary/RouteSummary.component.js